/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { OutbOrd02ProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const outbOrd02ProcessFetchProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const outbOrd02ProcessFetchProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [OutbOrd02ProcessTypes.OUTB_ORD02_PROCESS_FETCH_PROCESS_LOADING]: outbOrd02ProcessFetchProcessLoading,
  [OutbOrd02ProcessTypes.OUTB_ORD02_PROCESS_FETCH_PROCESS_SUCCESS]: outbOrd02ProcessFetchProcessSuccess
});
